import { useState } from 'react';
import { Link, NavLink, Outlet } from 'react-router-dom';
import { AdminFloatingPanel } from './AdminFloatingPanel';
import { getSite } from '../lib/site';

const links = [
  { to: '/about', label: 'About' },
  { to: '/gallery', label: 'Gallery' },
  { to: '/commissions', label: 'Commissions' },
  { to: '/shows', label: 'Shows' },
  { to: '/testimonials', label: 'Testimonials' },
  { to: '/contact', label: 'Contact' },
];

export function Layout() {
  const site = getSite();
  const [open, setOpen] = useState(false);

  return (
    <>
      <header className="site-header">
        <div className="wrap nav-inner">
          <Link to="/" className="brand" onClick={() => setOpen(false)}>
            Su&apos;s <span className="brand-silent">Silent</span>{' '}
            <span className="brand-strokes">Strokes</span>
          </Link>
          <button
            type="button"
            className="nav-toggle"
            aria-expanded={open}
            onClick={() => setOpen((v) => !v)}
          >
            Menu
          </button>
          <nav className={`nav-links${open ? ' open' : ''}`} aria-label="Primary">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                className={({ isActive }) => (isActive ? 'active' : undefined)}
                onClick={() => setOpen(false)}
              >
                {l.label}
              </NavLink>
            ))}
          </nav>
        </div>
      </header>
      <main>
        <Outlet />
      </main>
      <footer className="site-footer">
        <div className="wrap footer-inner">
          <div>
            <strong className="display" style={{ fontSize: '1.2rem' }}>
              {site.name}
            </strong>
            <p style={{ margin: '0.25rem 0 0' }}>{site.tagline}</p>
          </div>
          <div>
            <a href={`mailto:${site.email}`}>{site.email}</a>
            <div style={{ marginTop: 4 }} className="footer-payments">
              {site.payments.methods.map((m, i) => (
                <span key={m.label}>
                  {i > 0 ? ' · ' : null}
                  {m.label}{' '}
                  {m.href ? (
                    <a href={m.href} target="_blank" rel="noreferrer">
                      {m.handle}
                    </a>
                  ) : (
                    <span className="payment-handle">{m.handle}</span>
                  )}
                </span>
              ))}
            </div>
            <div style={{ marginTop: 4 }}>
              <a href={`https://${site.domain}`}>{site.domain}</a>
            </div>
          </div>
        </div>
      </footer>
      {/* Floating admin — stays while navigating after sign-in */}
      <AdminFloatingPanel />
    </>
  );
}
